<template>
    <div class="marketing-options">
        <p class="title typographies-paragraph-x-large-semibold">
            {{ $l10n.__('Options marketing') }}
        </p>
        <div class="option">
            <CompassSwitch :value="true" :disabled="true" size="medium" />
            <div class="option__content">
                <span class="typographies-paragraph-medium-regular">
                    {{ $l10n.__('Marketing') }}
                </span>
                <p class="typographies-paragraph-medium-regular option__description">
                    {{
                        $l10n.__(
                            'Collectez des leads et créez des superbes campagnes emailing, SMS et automation',
                        )
                    }}
                </p>
                <CompassSelect
                    :value="marketingLevelSelectedOption.id"
                    class="option-select-marketing-plan"
                    @update:value="
                        (value) =>
                            updateLevelOption({
                                optionNameKey: 'pack_marketing',
                                optionId: value,
                            })
                    "
                >
                    <CompassDropdownSelectOption
                        v-for="marketingLevel in options.pack_marketing"
                        :key="marketingLevel.id"
                        :disabled="checkMarketingLevelOptionDisabled(marketingLevel.item_id)"
                        :label="marketingLevel.level"
                        :value="marketingLevel.id"
                    />
                </CompassSelect>
            </div>
            <p class="typographies-paragraph-medium-semibold price">
                <span class="typographies-paragraph-medium-semibold">
                    {{ priceMarketingLevelSelected }}
                </span>
                <span
                    v-if="marketingLevelSelectedOption.amount > 0"
                    class="typographies-paragraph-medium-regular"
                >
                    /{{ recurrencyLabel(marketingLevelSelectedOption.unit_period) }}</span
                >
            </p>
        </div>
        <div class="upsell-marketing-items">
            <!--        Pack 10 000 e-mails supplémentaires/mois      -->
            <ChargebeeUpsellMarketingItemEmailPack
                :data="packMarketingEmailFull"
                :enabled="packMarketingEmailIsEnabled"
                :label="
                    $t.__(
                        'pages.account.upsell.marketing.ChargebeeUpsellMarketing.pack_additional_emails',
                    )
                "
                :number-chosen="packMarketingEmailFull.quantity"
                :amount="packMarketingEmailFull.price"
                :tooltip-text="
                    $t.__(
                        'pages.account.upsell.marketing.ChargebeeUpsellMarketing.purchase_one_time_credits_from_your_settings',
                    )
                "
                @onNumberChosenChange="(numberChosen) => updatePackEmailQuantity(numberChosen)"
            />

            <!--        Envoi multi-domaines      -->
            <ChargebeeUpsellMarketingItem
                :description="
                    $t.__(
                        'pages.account.upsell.marketing.ChargebeeUpsellMarketing.use_multiple_sending_domains',
                    )
                "
                :enabled="getMarketingOptionSelectedLevel === marketingLevelEnum.BUSINESS"
                :label="
                    $t.__(
                        'pages.account.upsell.marketing.ChargebeeUpsellMarketing.multi_domain_sending',
                    )
                "
                :amount="options.pack_marketing_multi_domains_auth.price"
                :tooltip-text="
                    $t.__(
                        'pages.account.upsell.marketing.ChargebeeUpsellMarketing.purchase_one_time_credits_from_your_settings',
                    )
                "
            >
                <CompassSwitch
                    :value="isOptionEnabled(marketingOptionEnum.MULTIDOMAIN)"
                    :disabled="packMarketingMultiDomainIsDisabled"
                    size="medium"
                    @input="(value) => updateOption(marketingOptionEnum.MULTIDOMAIN, value)"
                />
            </ChargebeeUpsellMarketingItem>

            <!--        Délégation et hébergement du domaine d’envoi      -->
            <div>
                <ChargebeeUpsellMarketingItem
                    :description="
                        $t.__(
                            'pages.account.upsell.marketing.ChargebeeUpsellMarketing.to_optimize_your_deliverability_with_ease',
                        )
                    "
                    :label="
                        $t.__(
                            'pages.account.upsell.marketing.ChargebeeUpsellMarketing.domain_authentification',
                        )
                    "
                    :amount="options.pack_marketing_custom_domain.price"
                    :tooltip-text="
                        $t.__(
                            'pages.account.upsell.marketing.ChargebeeUpsellMarketing.to_configure_multiple_domains',
                        )
                    "
                >
                    <CompassSwitch
                        :value="isOptionEnabled(marketingOptionEnum.DOMAIN)"
                        size="medium"
                        :disabled="
                            getOptionWasEnabledPreviously({
                                optionNameKey: marketingOptionEnum.DOMAIN,
                            })
                        "
                        @input="(value) => updateOption(marketingOptionEnum.DOMAIN, value)"
                    />
                </ChargebeeUpsellMarketingItem>
                <ChargebeeUpsellMarketingDomainsManager
                    v-show="isOptionEnabled(marketingOptionEnum.DOMAIN)"
                    :recurrence="getRecurrence"
                    :unitPriceDomain="options.pack_marketing_custom_domain.price"
                    :isMultiDomainsEnabled="isOptionEnabled(marketingOptionEnum.MULTIDOMAIN)"
                    :isEnabled="isOptionEnabled(marketingOptionEnum.DOMAIN)"
                />
            </div>

            <!--        IP dédiée      -->
            <ChargebeeUpsellMarketingItem
                :description="
                    $t.__(
                        'pages.account.upsell.marketing.ChargebeeUpsellMarketing.ideal_option_for_improving_deliverability_over_time',
                    )
                "
                :enabled="getMarketingOptionSelectedLevel === marketingLevelEnum.BUSINESS"
                :label="
                    $t.__('pages.account.upsell.marketing.ChargebeeUpsellMarketing.dedicated_ip')
                "
                :amount="options.pack_marketing_dedicated_ip.price"
                :tooltip-text="
                    $t.__(
                        'pages.account.upsell.marketing.ChargebeeUpsellMarketing.can_choose_two_dedicated_ips_max',
                    )
                "
            >
                <CompassSelect
                    :value="dedicatedIpOptionQuantity.toString()"
                    :disabled="getMarketingOptionSelectedLevel !== marketingLevelEnum.BUSINESS"
                    @update:value="(value) => updateDedicatedIpQuantity(value)"
                >
                    <CompassDropdownSelectOption
                        v-for="(_, n) of 3"
                        :key="n"
                        :label="n.toString()"
                        :value="n.toString()"
                    />
                </CompassSelect>
            </ChargebeeUpsellMarketingItem>
        </div>
    </div>
</template>
<script>
import generateHash from 'Helpers/hashGenerator.js';
import ChargebeeUpsellMarketingItem from 'vcomponents/pages/account/upsell/marketing/ChargebeeUpsellMarketingItem.vue';
import ChargebeeUpsellMarketingItemEmailPack from 'vcomponents/pages/account/upsell/marketing/ChargebeeUpsellMarketingItemEmailPack.vue';
import ChargebeeUpsellMarketingDomainsManager from 'vcomponents/pages/account/upsell/marketing/ChargebeeUpsellMarketingDomainsManager.vue';
import ChargebeeUpsellMixin from 'mixins/chargebee/ChargebeeUpsellMixins';
import { cloneDeep, debounce } from 'lodash';
import { createNamespacedHelpers } from 'vuex';
const chargebeeUpsellStore = createNamespacedHelpers('chargebeeUpsellStore');
const marketingLevelEnum = Object.freeze({
    STARTER: 'starter',
    BUSINESS: 'business',
    PRO: 'pro',
});
const marketingOptionEnum = Object.freeze({
    MULTIDOMAIN: 'pack_marketing_multi_domains_auth',
    DOMAIN: 'pack_marketing_custom_domain',
});
export default {
    components: {
        ChargebeeUpsellMarketingItem,
        ChargebeeUpsellMarketingDomainsManager,
        ChargebeeUpsellMarketingItemEmailPack,
    },
    mixins: [ChargebeeUpsellMixin],
    data() {
        return {
            marketingLevelEnum,
            marketingOptionEnum,
            oldMarketingLevelSelectedOption: {},
        };
    },
    computed: {
        ...chargebeeUpsellStore.mapGetters([
            'getSubscriptionItems',
            'getChargebeeCatalogue',
            'getPlanSelected',
            'getPreviousSubscriptionItems',
            'getRecurrence',
            'getDomains',
            'getPlanSelected',
        ]),
        packMarketingEmailFull() {
            const data = {};
            const itemsFromSubscription = this.getSubscriptionItems.filter(
                (item) => item.nameKey === 'pack_marketing_email',
            );

            data.price =
                this.options?.pack_marketing_email?.find((item) =>
                    item.id.includes(this.getMarketingOptionSelectedLevel),
                )?.price ?? 0;
            data.quantity = itemsFromSubscription.reduce((sum, record) => sum + record.quantity, 0);

            return data;
        },
        getMarketingOptionSelectedLevel() {
            const exploded = this.marketingLevelSelectedOption.id.split('_');
            return exploded[2];
        },
        marketingLevelSelectedOption() {
            const marketingSelectValue =
                this.getSubscriptionItems.find((option) => option.nameKey === 'pack_marketing') ??
                this.options.pack_marketing[0];
            marketingSelectValue.id = marketingSelectValue.id ?? marketingSelectValue.item_price_id;
            marketingSelectValue.amount = marketingSelectValue.amount ?? marketingSelectValue.price;
            marketingSelectValue.unit_period = this.getRecurrence;
            return marketingSelectValue;
        },
        dedicatedIpOptionQuantity() {
            const quantity =
                this.getSubscriptionItems.find(
                    (item) => item.nameKey === 'pack_marketing_dedicated_ip',
                )?.quantity ?? 0;
            return quantity;
        },
        options() {
            return this.getChargebeeCatalogue[this.getPlanSelected]?.addons.options;
        },
        priceMarketingLevelSelected() {
            return this.marketingLevelSelectedOption.amount === 0
                ? this.$l10n.__('Inclus')
                : this.$options.filters.numberformatCurrency(
                      this.humanizeCentsPrice(this.marketingLevelSelectedOption.amount),
                  );
        },
        packMarketingEmailIsEnabled() {
            return [marketingLevelEnum.BUSINESS, marketingLevelEnum.PRO].includes(
                this.getMarketingOptionSelectedLevel,
            );
        },
        packMarketingMultiDomainIsDisabled() {
            return (
                this.getMarketingOptionSelectedLevel !== marketingLevelEnum.BUSINESS ||
                this.getOptionWasEnabledPreviously({
                    optionNameKey: marketingOptionEnum.MULTIDOMAIN,
                })
            );
        },
    },
    created() {
        this.oldMarketingLevelSelectedOption = cloneDeep(this.marketingLevelSelectedOption);
    },
    mounted() {
        this.setOptionFromUrlParams();
    },
    methods: {
        ...chargebeeUpsellStore.mapActions([
            'updateOptionLevel',
            'updatePackMarketingEmailLevelAndDiscounts',
            'updateOptionStatus',
            'updateAddonQuantity',
            'removeAddonByNamekey',
            'updateDomain',
        ]),
        async setOptionFromUrlParams() {
            if (
                this.$route.query[marketingOptionEnum.MULTIDOMAIN] &&
                this.getBoolFromUrlParam(marketingOptionEnum.MULTIDOMAIN) &&
                !this.packMarketingMultiDomainIsDisabled
            ) {
                await this.updateOptionStatus({
                    optionNameKey: marketingOptionEnum.MULTIDOMAIN,
                    value: true,
                });
            }

            if (
                this.$route.query[marketingOptionEnum.DOMAIN] &&
                this.getBoolFromUrlParam(marketingOptionEnum.DOMAIN)
            ) {
                await this.updateOptionStatus({
                    optionNameKey: marketingOptionEnum.DOMAIN,
                    value: true,
                });
            }

            if (
                this.$route.query[marketingOptionEnum.DOMAIN + '_add'] &&
                this.getBoolFromUrlParam(marketingOptionEnum.DOMAIN + '_add') &&
                this.isOptionEnabled(marketingOptionEnum.MULTIDOMAIN)
            ) {
                await this.updateDomain({
                    sender: '',
                    name: '',
                    subDomain: '',
                    extension: 'FR',
                    hash: generateHash(),
                    isValidated: false,
                    canBeModified: true,
                });
            }
        },
        getBoolFromUrlParam(param) {
            if (this.$route.query[param]) {
                return this.$route.query[param].toLowerCase() === 'true';
            }
            return false;
        },
        getOptionWasEnabledPreviously({ optionNameKey }) {
            return this.getPreviousSubscriptionItems.some((item) => item.nameKey === optionNameKey);
        },
        updateLevelOption: debounce(async function ({ optionNameKey, optionId }) {
            try {
                if (optionId === this.marketingLevelSelectedOption.id) {
                    return;
                }
                const selectedValue = this.options[optionNameKey].find((option) => {
                    return option.id === optionId;
                });
                await this.updateOptionLevel({ optionNameKey, option: selectedValue });

                if (this.getMarketingOptionSelectedLevel !== marketingLevelEnum.STARTER) {
                    const newSubOption = this.options.pack_marketing_email.find((item) =>
                        item.id.includes(this.getMarketingOptionSelectedLevel),
                    );

                    await this.updatePackMarketingEmailLevelAndDiscounts({
                        optionNameKey: 'pack_marketing_email',
                        newSubOption,
                    });
                } else {
                    //remove additionnal marketing email option if exists
                    await this.removeAddonByNamekey('pack_marketing_email');
                }

                if (this.getMarketingOptionSelectedLevel !== marketingLevelEnum.BUSINESS) {
                    if (this.isOptionEnabled(marketingOptionEnum.MULTIDOMAIN)) {
                        await this.updateOptionStatus({
                            optionNameKey: marketingOptionEnum.MULTIDOMAIN,
                            value: false,
                        });
                    }
                    if (this.isOptionEnabled('pack_marketing_dedicated_ip')) {
                        this.updateDedicatedIpQuantity(0);
                    }
                }
            } catch (e) {
                this.callError(e);
            }
        }, 200),
        checkMarketingLevelOptionDisabled(option) {
            const order = {
                pack_marketing_starter_full: 0,
                pack_marketing_pro_full: 1,
                pack_marketing_business_full: 2,
            };
            return (
                order[option] <
                order[this.oldMarketingLevelSelectedOption.id.replace(/(_monthly|_yearly)/, '')]
            );
        },
        updatePackEmailQuantity: debounce(function (value) {
            try {
                const id = this.options.pack_marketing_email.find((option) =>
                    option.id.includes(this.getMarketingOptionSelectedLevel),
                )?.id;
                this.updateAddonQuantity({
                    addonId: id,
                    quantity: value,
                    isOption: true,
                });
            } catch (e) {
                this.callError(e);
            }
        }, 300),
        updateDedicatedIpQuantity: debounce(function (value) {
            try {
                this.updateAddonQuantity({
                    addonId: this.options.pack_marketing_dedicated_ip?.id ?? '',
                    quantity: +value,
                    isOption: true,
                });
            } catch (e) {
                this.callError(e);
            }
        }, 300),
    },
};
</script>

<style lang="scss" scoped>
.marketing-options {
    display: flex;
    flex-direction: column;

    .title {
        margin-bottom: var(--spacing-1);
    }

    p {
        margin: 0;
    }

    .option {
        align-content: start;
        border-bottom: 1px solid var(--colors-common-border-lighter);
        display: flex;
        gap: var(--spacing-3);
        padding: var(--spacing-3) 0 var(--spacing-4);

        .price {
            min-width: 100px;
            text-align: right;
            white-space: nowrap;
        }

        &__content {
            flex-grow: 1;
        }

        &__description {
            color: var(--colors-common-text-standard-caption);
            margin-bottom: var(--spacing-1);
        }

        .compass-switch {
            flex-shrink: 0;
        }

        &-select-marketing-plan {
            width: 100%;
        }
    }

    .upsell-marketing-items {
        display: flex;
        flex-direction: column;

        & > div:not(:last-child) {
            border-bottom: 1px solid var(--colors-common-border-lighter);
            padding: var(--spacing-3) 0;
        }

        & > div:last-child {
            padding-top: var(--spacing-3);
        }
    }
}
</style>
